export default __webpack_public_path__ + "static/media/icon_employee.251e2682.svg";